import useNetworkStatus from "@hooks/useNetworkStatus";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NetworkGuard = ({ children }) => {
  const isOnline = useNetworkStatus();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isOnline && location.pathname !== "/no-connection") {
      navigate("/no-connection", { replace: true });
    }

    if (isOnline && location.pathname === "/no-connection") {
      navigate(-1); // go back to last page
    }
  }, [isOnline, navigate, location.pathname]);

  return children;
};

export default NetworkGuard;
